import Skeleton from "common/components/ui/Skeleton";
import { formatPrice } from "common/helpers/utils";

interface ToPayNowProps {
  estimate: { amountDue: number; nextBillingAt: number };
  isDowngradeOrEqual: boolean;
  isInTrial: boolean;
  isLoading: boolean;
}

export default function ToPayNow({
  estimate,
  isDowngradeOrEqual,
  isInTrial,
  isLoading,
}: ToPayNowProps) {
  return (
    <div className="flex items-center justify-between px-2 py-1">
      <span className="text-md-bold">To pay now</span>

      {isLoading || !estimate ? (
        <Skeleton className="h-8 w-24" />
      ) : (
        <span className="text-2xl-bold text-purple-600">
          {formatPrice(
            isDowngradeOrEqual || isInTrial ? 0 : estimate.amountDue / 100,
          )}
        </span>
      )}
    </div>
  );
}
